var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
// constants
import { prefix } from '../../constants';
// Inline printing requirements
import { iconsList } from '../../utils/iconsList';
const InlinePaths = ({ icon }) => {
    if (Array.isArray(icon.d)) {
        return (React.createElement(React.Fragment, null, icon.d.map((pathItem, key) => (React.createElement("g", { fill: pathItem.fill ? pathItem.fill : undefined, key: key },
            React.createElement("path", { d: pathItem.path }))))));
    }
    else {
        return React.createElement("path", { d: icon.d });
    }
};
export const Icons = (props) => {
    const { fill, iconName, size = 24, className, inline } = props, theRest = __rest(props, ["fill", "iconName", "size", "className", "inline"]);
    const icon = iconsList.find(icon => icon.id === iconName);
    // Return nothing if icon does not exist
    if (!icon) {
        return null;
    }
    return (React.createElement("svg", Object.assign({ height: size, width: size, style: { fill } }, theRest, { className: classNames(className, `${prefix}-icon`), viewBox: inline ? icon.viewBox : undefined }), inline ? React.createElement(InlinePaths, { icon: icon }) : React.createElement("use", { xlinkHref: `#${iconName}` })));
};
//# sourceMappingURL=Icons.js.map